








import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class HeaderVideo extends Vue {

    @Prop() public color!: string;
    @Prop() public src!: string;

    public ready = false;

    public mounted() {
        this.ready = true;
    }
    public pause() {
        const video: any = this.$refs.videoplayer;
        video.pause();
    }
}
